export const formatoTypes = {
    FORMATO_RESET: '[Formato] RESET',
    FORMATO_GET_START: '[Formato] GET_START',
    FORMATO_GET_COMPLETE: '[Formato] GET_COMPLETE',
    FORMATO_GET_ERROR: '[Formato] GET_ERROR',
}